import { isNonEmpty } from '@sgme/fp';
import { scheduledRunsApi } from 'apiConnector/scheduledRun/scheduledRuns';
import { ofType } from 'redux-observable';
import { filter, of } from 'rxjs';
import { catchError, debounceTime, map, mergeMap } from 'rxjs/operators';
import { scheduledRunActions } from 'state/scheduledRuns/actions';
import type { EpicWithThunk } from 'state/state.common';
import { extractHttpErrorMessage, type HttpError } from 'utils/http/httpClient.model';

export function checkNameEpic(): EpicWithThunk {
  return (actions$, _, { httpClient }) => {
    const { checkNameExists } = scheduledRunsApi(httpClient);

    return actions$.pipe(
      ofType('SCHEDULED_RUN_TITLE_CHANGED'),
      debounceTime(1000),
      filter(({ title }) => isNonEmpty(title)),
      mergeMap(({ id, title }) => {
        return checkNameExists(title!).pipe(
          map(() => scheduledRunActions.scheduledRunNameChecked(id, title)),
          catchError((err: HttpError) => {
            if (err.status === 404) {
              return of(scheduledRunActions.scheduledRunNameChecked(id, undefined));
            } else {
              return of(scheduledRunActions.scheduledRunNameCheckFailed(id, extractHttpErrorMessage(err)));
            }
          }),
        );
      }),
    );
  };
}
